import { render } from "./CollectClubDeals.vue?vue&type=template&id=67a58d9c&scoped=true&ts=true"
import script from "./CollectClubDeals.vue?vue&type=script&lang=ts"
export * from "./CollectClubDeals.vue?vue&type=script&lang=ts"

import "./CollectClubDeals.vue?vue&type=style&index=0&id=67a58d9c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a58d9c"]])

export default __exports__